import React, { useState, useEffect } from 'react';
import banner1 from '../assets/me1.jpg';
import banner2 from '../assets/me2.png';
import banner3 from '../assets/carousel1.jpg';

const Banner = () => {
  const images = [banner1, banner2, banner3];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000); // Change image every 4 seconds

    return () => clearInterval(interval);
  });

  return (
    <div className="relative w-full h-[300px] md:h-[600px] overflow-hidden">
      {/* Slideshow Images */}
      {images.map((image, index) => (
        <img
          key={index}
          src={image}
          alt={`Slide ${index + 1}`}
          className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out
            ${index === currentImageIndex ? "opacity-100 scale-100" : "opacity-0 scale-105"}`}
        />
      ))}

      {/* Overlay Effect */}
      <div className="absolute inset-0 bg-black bg-opacity-30"></div>
    </div>
  );
};

export default Banner;
